var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InlineRow',[_c('label',{staticClass:"mr-5",class:{ required: _vm.required },attrs:{"for":_vm.forId}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }